import instance from 'utils/axios/instance.axios';
import { SCIENTIFIC_PROFILES } from './_constant';

export const uploadFile = (file) => instance.patch(SCIENTIFIC_PROFILES.UPLOAD_FILE, file);

export const downloadFile = () =>
  instance.get(SCIENTIFIC_PROFILES.DOWNLOAD_FILE, { responseType: 'blob' });

export const create = (data = {}) => instance.post(SCIENTIFIC_PROFILES.CREATE, data);

export const update = (data = {}) => instance.patch(SCIENTIFIC_PROFILES.UPDATE, data);

export const getGeneralInfo = () => instance.get(SCIENTIFIC_PROFILES.GET_GENERAL_INFO);

export const getAcademicHistory = () => instance.get(SCIENTIFIC_PROFILES.GET_ACADEMIC_HISTORY);

export const getWorkHistory = () => instance.get(SCIENTIFIC_PROFILES.GET_WORK_HISTORY);

export const getProjects = () => instance.get(SCIENTIFIC_PROFILES.GET_PROJECTS);

export const getThesisGuidances = () => instance.get(SCIENTIFIC_PROFILES.GET_THESIS_GUIDANCES);

export const getScientificWorks = () => instance.get(SCIENTIFIC_PROFILES.GET_SCIENTIFIC_WORKS);

export const getOthersInfo = () => instance.get(SCIENTIFIC_PROFILES.GET_OTHERS_INFO);

export const createPublicProfileId = (id) =>
  instance.post(SCIENTIFIC_PROFILES.CREATE_PUBLIC_PROFILE_ID(id));
